export const EDIT_TEACHER_PROFILE_SUCCESS="profile/EDIT_TEACHER_PROFILE_SUCCESS";
export const EDIT_TEACHER_PROFILE_FAILURE="profile/EDIT_TEACHER_PROFILE_FAILURE";
export const TEACHER_PROFILE_DETAILS_SUCCESS="profile/TEACHER_PROFILE_DETAILS_SUCCESS";
export const TEACHER_PROFILE_DETAILS_FAILURE="profile/TEACHER_PROFILE_DETAILS_FAILURE";


